import styles from './StatusBadge.module.css';

export type StatusBadgeTone = 'live' | 'test';

interface StatusBadgeProps {
  /** The short text shown in the badge. */
  label: string;
  /** `live`: solid green, for something on production. `test`: dashed amber, for something that is not. */
  tone: StatusBadgeTone;
  /** Longer explanation shown on hover. */
  hint?: string;
}

// A small pill that says whether something is live or still a test. It only draws; the caller decides when to show it and what it says.
export const StatusBadge = ({ label, tone, hint }: StatusBadgeProps) => (
  <span className={`${styles.badge} ${styles[tone]}`} title={hint}>
    {label}
  </span>
);
